import { Chip, Stack } from '@mui/material'

export function AppConnectionCardBlockCardInner({
  showConnectedChrome,
  statusLabel,
  chipColor,
}) {
  if (showConnectedChrome) return null
  return (
    <Stack sx={{ p: '12px', pt: 1.5, alignItems: 'center' }}>
      <Chip
        label={statusLabel}
        color={chipColor}
        variant="outlined"
        size="small"
        aria-label={`Connection status: ${statusLabel}`}
        sx={{ textTransform: 'none', fontWeight: 600, height: 26 }}
      />
    </Stack>
  )
}
